module.exports = __webpack_public_path__ + "dbe8505cf4eb137c63b6c375e02c225e.woff2";